export enum KYCStatus {
    newKYC = "NEW-KYC",
    failed = 'FAILED',
    pending = 'PENDING',
    approved = "APPROVED",
    autoApproved = "AUTO-APPROVED"
}

export type UserType = {
    full_name: string;
    country_id: string;
    profile_picture: string;
    email: string;
    status: number;
    email_verified: number;
    phone_verified: number;
    mobile: number;
    // change to proper object
    timezone: any;
    company_name: string;
    language: string;
    company_id: string;
    user_id: string;
    company_signup: string;
    user_signup: string;
    features: Array<string>;
    kycStatus: KYCStatus;
    customer_type_id: number;
    account_name: string;
    chatbot_custom_code: number | string;
    privileges:{[key: string]: any};
}